import React from 'react';
import GameButton from "./GameButton";
import { auth } from '../App';

function ChatMessage({message, UpdateScore}) {
  const { text, uid, isAI, docRef} = message;

  const messageClass = uid === auth.currentUser.uid ? 'sent' : 'received';
  const isSender = messageClass === 'sent' ?  "none": "";
 
  return (<>
    <div className={`message ${messageClass}`}>
      
      <GameButton UpdateScore ={UpdateScore} isAI={isAI} isSender ={isSender} docRef ={docRef}/>
      
      <p style={{marginTop: 5}}>{text}</p>
      
    </div>
  </>);
}

export default ChatMessage;
